import * as React from 'react';

function SvgEdit(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.5 10.5l-2.908-2.908-8.834 8.834-.718 3.626 3.626-.718L16.5 10.5zM15.713 5.47l1.379-1.378L20 7l-1.379 1.379-2.908-2.909z"
        fill="currentColor"
      />
      <path
        d="M11 20h9m-3.5-9.5l-2.908-2.908-8.834 8.834-.718 3.626 3.626-.718L16.5 10.5zm-.787-5.03l1.379-1.378L20 7l-1.379 1.379-2.908-2.909z"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default SvgEdit;
